import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { CommonModule, CurrencyPipe } from '@angular/common';

export interface DiscountedProductDetail {
  productCode: string;
  productName: string;
  productImage: string;
  itemQuantity: number;
  originalAmount: number;
  discountAmount: number;
  finalAmount: number;
  discountApplied: boolean;
  discountReason: string;
}

export interface DiscountedItemsDialogData {
  productDetails: DiscountedProductDetail[];
}

@Component({
  selector: 'app-discounted-items-modal',
  templateUrl: './discounted-items-modal.component.html',
  styleUrls: ['./discounted-items-modal.component.scss'],
  standalone: true,
  imports: [CommonModule, CurrencyPipe],
})
export class DiscountedItemsModalComponent {
  constructor(
    public dialogRef: MatDialogRef<DiscountedItemsModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DiscountedItemsDialogData,
  ) {}

  close(): void {
    this.dialogRef.close();
  }
}
